import React from "react";
import { useLocation } from "react-router-dom";

import { PullToRefreshProvider } from "context/PullToRefreshContext";
import SideBar from "./SideBar";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

type AppLayoutProps = {
  children: React.ReactNode;
};

export default function AppLayout({ children }: Readonly<AppLayoutProps>) {
  const { pathname } = useLocation();
  const { userToken } = useSelector((state: RootState) => state.authState);

  const hideSideBar =
    pathname.startsWith("/auth") ||
    pathname.startsWith("/invited") ||
    pathname.startsWith("/signup");

  return (
    <main className={styles.main}>
      <PullToRefreshProvider>
        {!hideSideBar && userToken && <SideBar />}
        {children}
      </PullToRefreshProvider>
    </main>
  );
}
